import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Table, Popover, Badge} from 'antd'
import {toJS} from 'mobx'
import moment from 'moment'
import {withTranslation} from 'react-i18next'

@inject('jobManagementStore')
@observer
class BatchDetailModal extends Component {
  formRef = React.createRef()
  state = {
    timer: null,
  }

  componentDidMount() {
    const {jobManagementStore, batchId} = this.props
    if (batchId) {
      this.setState({
        timer: setInterval(() => {
          jobManagementStore.getBatchDetail(batchId)
        }, 5000)
      })
    }

  }

  onClose = () => {
    const {handleCancel} = this.props
    clearInterval(this.state.timer)
    handleCancel()
  }

  render() {
    const {jobManagementStore, batchModalVisible, t} = this.props
    const {batchList} = jobManagementStore
    return (
      <>
        <Modal
          title={t(`job.inboundStatus`)}
          visible={batchModalVisible}
          // onOk={this.handleOk}
          onCancel={this.onClose}
          maskClosable={false}
          destroyOnClose={true}
          centered
          width="80%"
          footer={null}
        >
          <Table dataSource={toJS(batchList)} rowKey="id">
            <Table.Column title={t(`job.inboundName`)} dataIndex="inboundName" key="inboundName"/>
            <Table.Column title={t(`job.startTime`)} dataIndex="startTime" key="startTime"
                          render={(text) => moment(text).format('YYYY-MM-DD HH:mm:ss')}/>
            <Table.Column title={t(`job.endTime`)} dataIndex="endTime" key="endTime" render={(text) => moment(text).format('YYYY-MM-DD HH:mm:ss')}/>
            <Table.Column title={t(`job.duration`)} dataIndex="duration" key="duration"/>
            <Table.Column title={t(`job.messageId`)} dataIndex="messageIds" render={(text, record) => (
              text ? <Popover key={record.id} content={text?.split(',')?.map(item => (<span style={{display: 'block'}}>{item}</span>))}
                              style={{color: '#007aff'}}>{text?.split(',')[0]}...</Popover> : null
            )}/>
            <Table.Column title={t(`job.status`)} dataIndex="status" key="status" render={(text, record) => (
              <>
                <Badge status={text === 'SUCCESSFUL' ? 'success' : text === 'ERROR' ? 'error' : 'processing'}/>
                <span>{text}</span>
              </>
            )}/>
          </Table>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(BatchDetailModal)
